import NewCreation from "../pages/newCreation";
import UserManagement from "../pages/userManagement";
import Firmenprojekte from "../pages/firmenprojekte";
import FirmenprojekteListe from "../pages/milestones";
import Dashboard from "../pages/dashboard";
import AllNotes from "../components/allNotes";
import Documents from "../pages/documents";
import InfoCrawler from "../pages/infoCrawler";
import MailHistory from "../pages/icMailHistory";
import Storfalle from "../pages/Storfalle";
import InfoMail from "../pages/infoMail";
import AdminEditSubsteps from "../pages/adminEdit/adminEditSubsteps";
import AdminEditNotes from "../pages/adminEdit/adminEditNotes";
import AdminEditMilestones from "../pages/adminEdit/adminEditMilestones";
import AdminEditFooter from "../pages/adminEdit/adminEditFooter";
import AdminEditFunctions from "../pages/adminEdit/adminEditFunctions";
import AdminEditProzessOptions from "../pages/adminEdit/adminEditProzessOptions";
import AdminWeeklyReport from "../pages/adminEdit/adminWeeklyReport";
import AdminUIKit from "../pages/adminEdit/adminUIKit";
import Reporting from "../pages/reporting";
import Upselling from "../pages/Upselling";
import WVHistorie from "../pages/WV-Historie";
import ReportingUpselling from "../pages/reportingUpselling";
import AdminEditPotenzialParameter from "../pages/adminEdit/adminEditPotenzialParameter";
import Support from "../pages/support";
import DashboardV2 from "../pages/dashboardv2";
import BCCRecipient from "../pages/adminEdit/AdminStrings";
import PlanungKalender from "../pages/planungsKalender";
import AdminStrings from "../pages/adminEdit/AdminStrings";
import EmailReports from "../pages/adminEdit/adminEmailReports/emailReports";
import Logger from "../pages/adminEdit/Logger";
import PlaceholderManagement from "../pages/iFEx/PlaceholderManagement";
import DocumentManagement from "../pages/iFEx/DocumentManagement";
import DocumentGeneration from "../pages/iFEx/DocumentGeneration";
import Settings from "../pages/iFEx/Settings";
import TokenAccess from "../pages/TokenAccess";

export const RouteData = [
    {
        id: 0,
        path: '/',
        name: 'dashboard',
        component: <DashboardV2/>,
        redirection: '/anmeldung'
    },
    {
        id: 1,
        path: '/neu',
        name: 'new',
        component: <NewCreation/>,
        redirection: '/anmeldung'
    },
    {
        id: 2,
        path: "/benutzerverwaltung",
        name: 'benutzerverwaltung',
        component: <UserManagement/>,
        redirection: '/anmeldung'
    },
    {
        id: 3,
        path: "/benutzerubersicht",
        name: 'Benutzerübersicht',
        component: <UserManagement/>,
        redirection: '/anmeldung'
    },
    {
        id: 4,
        path: '/firmenprojekte-liste',
        name: 'bestand-list',
        component: <Firmenprojekte/>,
        redirection: '/anmeldung'
    },
    {
        id: 5,
        path: 'firmenprojekte/:portal/:id',
        name: 'bestand',
        component: <FirmenprojekteListe/>,
        redirection: '/anmeldung'
    },
    {
        id: 6,
        path: '/dateinachweise/:portal/:company',
        name: 'dateinachweise',
        component: <Documents/>,
        redirection: '/anmeldung'
    },
    {
        id: 7,
        path: 'alle-notizen/:portal/:company',
        name: 'allNotes',
        component: <AllNotes/>,
        redirection: '/anmeldung'
    },
    {
        id: 8,
        path: 'info-crawler',
        name: 'infoCrawler',
        component: <InfoCrawler/>,
        redirection: '/anmeldung'
    },
    {
        id: 9,
        path: 'mail-verlauf',
        name: 'mailVerlauf',
        component: <MailHistory/>,
        redirection: '/anmeldung'
    },
    {
        id: 10,
        path: 'storfalle',
        name: 'Störfälle',
        component: <Storfalle/>,
        redirection: '/anmeldung'
    },
    {
        id: 11,
        path: 'info-mail',
        name: 'infomail',
        component: <InfoMail/>,
        redirection: '/anmeldung'
    },
    {
        id: 12,
        path: 'admin-edit',
        name: 'adminEdit',
        component: <AdminEditSubsteps/>,
        redirection: '/anmeldung'
    },
    {
        id: 13,
        path: 'admin-edit-milestones',
        name: 'adminEditLabel',
        component: <AdminEditMilestones/>,
        redirection: '/anmeldung'
    },
    {
        id: 14,
        path: 'admin-edit-footer',
        name: 'adminEditFooter',
        component: <AdminEditFooter/>,
        redirection: '/anmeldung'
    },
    {
        id: 15,
        path: 'admin-edit-options',
        name: 'adminEditOptions',
        component: <AdminEditNotes/>,
        redirection: '/anmeldung'
    },
    {
        id: 16,
        path: 'dienstleistungen/:portal/:id',
        name: 'upselling',
        component: <Reporting/>,
        redirection: '/anmeldung'
    },
    {
        id: 17,
        path: 'dienstleistungen',
        name: 'Dienstleistungen',
        component: <Upselling/>,
        redirection: '/anmeldung'
    },
    {
        id: 18,
        path: 'WV-Historie',
        name: 'WV-Historie',
        component: <WVHistorie/>,
        redirection: '/anmeldung'
    },
    {
        id: 19,
        path: 'reporting-upselling',
        name: 'reporting_upselling',
        component: <ReportingUpselling/>,
        redirection: '/anmeldung'
    },
    {
        id: 20,
        path: 'potenzial-parameter',
        name: 'potenzial-parameter',
        component: <AdminEditPotenzialParameter/>,
        redirection: '/anmeldung'
    },
    {
        id: 21,
        path: '/support',
        name: 'support',
        component: <Support/>,
        redirection: '/anmeldung'
    },
    {
        id: 21,
        path: '/dashboard_v1',
        name: 'dashboard_v1',
        component: <Dashboard/>,
        redirection: '/anmeldung'
    },
    {
        id: 22,
        path: '/firmenprojekte-liste/:mileStoneNumber',
        name: 'bestand-list',
        component: <Firmenprojekte/>,
        redirection: '/anmeldung'
    },
    {
        id: 23,
        path: 'admin-strings',
        name: 'AdminStrings',
        component: <AdminStrings/>,
        redirection: '/anmeldung'
    },
    {
        id: 24,
        path: 'planungskalender',
        name: 'PlanungKalender',
        component: <PlanungKalender/>,
        redirection: '/anmeldung'
    },
    {
        id: 25,
        path: '/email-reports',
        name: 'EmailReports',
        component: <EmailReports/>,
        redirection: '/anmeldung'
    },
    {
        id: 26,
        path: 'admin-edit-functions',
        name: 'adminEditFunctions',
        component: <AdminEditFunctions/>,
        redirection: '/anmeldung'
    },
    {
        id: 27,
        path: 'admin-edit-prozess-options',
        name: 'adminEditProzessOptions',
        component: <AdminEditProzessOptions/>,
        redirection: '/anmeldung'
    },
    {
        id: 140,
        path: 'admin-weekly-report',
        name: 'adminWeeklyReport',
        component: <AdminWeeklyReport/>,
        redirection: '/anmeldung'
    },
    {
        id: 141,
        path: 'admin-ui-kit',
        name: 'adminUIKit',
        component: <AdminUIKit/>,
        redirection: '/anmeldung'
    },
    {
        id: 28,
        path: 'logger',
        name: 'logger',
        component: <Logger/>,
        redirection: '/anmeldung'
    },
    {
        id: 29,
        path: 'print-center/platzhalter',
        name: 'printCenter-placeholders',
        component: <PlaceholderManagement/>,
        redirection: '/anmeldung'
    },
    {
        id: 30,
        path: 'print-center/dokumente',
        name: 'printCenter-documents',
        component: <DocumentManagement/>,
        redirection: '/anmeldung'
    },
    {
        id: 31,
        path: 'print-center/generieren',
        name: 'printCenter-generate',
        component: <DocumentGeneration/>,
        redirection: '/anmeldung'
    },
    {
        id: 32,
        path: 'print-center/einstellungen',
        name: 'printCenter-settings',
        component: <Settings/>,
        redirection: '/anmeldung'
    },
    {
        id: 33,
        path: 'access/:token',
        name: 'token-access',
        component: <TokenAccess/>,
        // No redirection - this is a public route for external token-based access
    },
]
